export default __webpack_public_path__ + "static/media/card-masha-2.b191741a.png";